import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from '../Services/storage.service';

@Component({
  selector: 'app-cvm-footer',
  templateUrl: './cvm-footer.component.html',
  styleUrls: ['./cvm-footer.component.scss']
})
export class CvmFooterComponent implements OnInit {

  con_user = null;

  constructor(private router:Router, private storagedata:StorageService) { 
    this.con_user = storagedata.getCongresConUser();
  }

  ngOnInit() {
  }

  preventAction($event){
    $event.preventDefault();
  }

  vcRegister($event){
    this.preventAction($event);
    this.con_user ? alert('Vous êtes déjà connecté!') : this.router.navigateByUrl('/congres-virtuel/auth');
  }

}
